// const FAQs = () => (
//   <div className="space-y-6">
//     <div>
//       <h3 className="font-semibold text-gray-900 mb-1">
//         Do I need prior trekking experience?
//       </h3>
//       <p>
//         No prior trekking experience is required for most treks such as Everest
//         Base Camp or Annapurna Base Camp. However, good physical fitness and
//         preparation are strongly recommended.
//       </p>
//     </div>

//     <div>
//       <h3 className="font-semibold text-gray-900 mb-1">
//         Is travel insurance mandatory?
//       </h3>
//       <p>
//         Yes. Travel insurance covering high-altitude trekking (up to 6,000m),
//         emergency evacuation, and medical expenses is mandatory.
//       </p>
//     </div>

//     <div>
//       <h3 className="font-semibold text-gray-900 mb-1">
//         When is the best season to trek in Nepal?
//       </h3>
//       <p>
//         The best seasons are Spring (March–May) and Autumn (September–November),
//         offering stable weather and clear mountain views.
//       </p>
//     </div>

//     <div>
//       <h3 className="font-semibold text-gray-900 mb-1">
//         Who will be our guides?
//       </h3>
//       <p>
//         All treks are led by licensed, experienced Nepali guides trained in
//         high-altitude safety and first aid.
//       </p>
//     </div>
//   </div>
// );

// export default FAQs;

"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import faqs from "../data/faqs";

export default function FAQs() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="space-y-4 text-gray-700">
      {faqs.map((item, idx) => {
        const isOpen = openIndex === idx;

        return (
          <div
            key={idx}
            className="border border-gray-200 rounded-xl overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(isOpen ? null : idx)}
              className="w-full flex items-center justify-between px-5 py-4 text-left font-medium text-gray-800 hover:bg-gray-50 transition"
            >
              {item.question}
              <ChevronDown
                className={`w-5 h-5 transition-transform ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {isOpen && (
              <div className="px-5 pb-4 text-sm leading-relaxed text-gray-600">
                {item.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
